"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
require("./education.scss");
const Education = (props) => {
    return (react_1.default.createElement(core_1.Box, { id: 'education', className: `v2-container-background ${props.className}` },
        react_1.default.createElement("h4", { className: 'v2-profile-block-heading' }, "Education"),
        props.education.map((el, i) => react_1.default.createElement("div", { key: i, className: "wrapper" },
            react_1.default.createElement("p", { className: 'university' }, el.school),
            react_1.default.createElement("p", null, el.degree),
            react_1.default.createElement("p", null, el.study),
            react_1.default.createElement("p", null,
                el.startYear,
                "-",
                el.endYear)))));
};
exports.default = Education;
